import styled from 'styled-components';
/* eslint-disable import/prefer-default-export */

export const Header = styled.h2`
  font-family: Inter;
  font-weight: bold;
  padding-left: 15px;
  margin-top: 40px;
`;
